import { useState, useEffect } from 'react';
import { Box, Stack, Typography, useTheme, TablePagination, Button, IconButton } from '@mui/material';
import React from 'react';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Datatable from '../../../components/DataTable';
import TablePaginationActions from '../../../components/TablePaginationActions';
import PageHeader from '../../../components/PageHeader';
import UserDetails from './Components/UserDetails';
import AddEditUser from './Components/AddEditUser';
import { useSelector } from 'react-redux';
import { CancelToken } from 'apisauce';
import appapi from '../../../api/apiClient';
import { dialogButtonCancel } from '../../../utils/commonStyle';
import RolePrivilageDialog from './Components/RolePrivilageDialog';
import ConfirmArchiveDialog from '../../../components/ConfirmArchiveDialog';
import ArchiveUserList from './Components/ArchiveUserList';
import { checkPermission } from '../../../redux/features/authSlice';
import { useTranslation } from 'react-i18next';
import AccessDenied from '../AccesDenied/AccessDenied';

export default function UserManagement() {
  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
      default: true,
      columnEditable: false,
      activeColumn: true,
    },
    {
      id: 1,
      header: 'Full name',
      accessor: 'name',
      width: '30%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 2,
      header: 'Designation',
      accessor: 'designation',
      width: '15%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 3,
      header: 'Role',
      accessor: 'role',
      width: '15%',
      default: true,
      capitalize: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [
          {
            label: 'Admin',
            value: 'admin',
          },
          {
            label: 'Standard',
            value: 'standard',
          },
        ],
      },
    },
    {
      id: 4,
      header: 'Email',
      accessor: 'email',
      width: '25%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 5,
      header: 'Phone',
      accessor: 'phoneNumber',
      width: '10%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      Cell: (value) => (
        <div className="flex ">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {value?.phoneCode || ''}
            {value?.phoneNumber || '-'}
          </Typography>
        </div>
      ),
    },
  ];

  const theme = useTheme();
  const { t } = useTranslation();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const [addEditUserOpen, setAddEditUserOpen] = useState(false);
  const [openRolePrivilage, setOpenRolePrivilage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  const [selectedHistory, setSelectedHistory] = useState(null);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [openArchiveList, setOpenArchiveList] = useState(false);

  const [selectedData, setSelectedData] = useState(null);
  const [type, setType] = useState('');
  const [roleId, setRoleId] = useState('');

  const [list, setList] = useState([])

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    role: null,
    field: '_id',
    sortOrder: 'desc',
  });

  const { companyDetails, user } = useSelector((state) => state.auth);

  const userPermission = useSelector((state) => checkPermission(state, 'User Management', 'Manage Users'));

  let source = CancelToken.source();
  const text = theme.palette.primary.text;

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    setSelectedHistory(checkedStatus ? item : null);
  };

  const handleOnArchive = (item) => {
    setOpenArchiveDialog(true);
  };

  useEffect(() => {
    setList(
      userList.map((res, index) => {
        return {
          ...res,
          isSelected: false,
        };
      }),
    );
  }, [userList]);

   useEffect(() => {
    if (list.length > 0) {
      if (selectedHistory) {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: res._id === selectedHistory._id,
          };
        });
        setList(items);
      } else {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: false,
          };
        });
        setList(items);
      }
    }
  }, [selectedHistory]);


  const handleGetUser = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/user-management/list/${user?.companyId}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        role: payload.role,
        field: payload.field === 'name' ? 'sortName' : payload.field === 'designation' ? 'sortDesignation' : payload.field,

        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setUserList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setUserList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setUserList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if(userPermission.viewAccess) {
      handleGetUser();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder, payload.role, userPermission.viewAccess]);

  const selectRow = (sitem, sindex) => {
    const users = userList.map((item, index) => {
      item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
      item.selected = item._id === sitem._id;
      return item;
    });
    setSelectedData(sitem);
    setUserList(users);
    setIsDrawerOpen(true);
  };

  const handleExcelDownload = async (format) => {
    const response = await appapi.get(
      `/user-management/excel/${user?.companyId}`,
      {
        filter: payload.filter ? payload.filter : null,
        role: payload.role,
        field: payload.field === 'name' ? 'sortName' : payload.field === 'designation' ? 'sortDesignation' : payload.field,
        sortOrder: payload.sortOrder,
        format,
      },
      { observe: 'response', responseType: 'blob' },
    );
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `USER${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  return (
    userPermission.viewAccess ? <Stack
      flex={1}
      direction={'row'}
      className="m-[8px] rounded-[8px] bg-white"
    >
      <Stack flex={1}>
        <PageHeader
          handleFilterButton={payload.totalLength > 0 ? true : false}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          showExport={userPermission?.addAccess ? (payload.totalLength > 0 ? true : false) : false}
          onExport={(type) => {
            handleExcelDownload(type);
          }}
          columnPreference={payload.totalLength > 0 ? true : false}
          columns={customerManagementColumn}
          applyColumnPreference={(c) => setCustomerManagementColumn(c)}
          showArchive={userPermission.archiveAccess}
          disableArchive={selectedHistory ? false : true}
          onArchive={(item) => handleOnArchive(item)}
          onRefresh={() => {
            if (payload.page === 1) {
              handleGetUser();
            } else {
              setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1 }));
            }
          }}
        >
          <Stack
            direction="row"
            flex={1}
          >
            {' '}
            <Stack flexGrow={1} />
            {userPermission.addAccess && (
              <Button
                sx={{ color: theme.palette.primary.main }}
                className="fs-14 ff-Roboto fw-medium !mr-[20px] !uppercase"
                onClick={() => {
                  setAddEditUserOpen(true);
                  setType('add');
                  setSelectedData(null);
                }}
                variant="text"
                startIcon={<PersonAddIcon />}
              >
                {t('Add user')}
              </Button>
            )}
          </Stack>
        </PageHeader>
        <Stack className="relative overflow-auto flex-auto  h-0">
          <Datatable
            tableHeadBgColor={'#e2eeff'}
            columns={customerManagementColumn.filter((res) => res.activeColumn)}
            data={list || []}
            isLoading={isLoading}
            onClickRow={(item, index) => {
              selectRow(item, index);
            }}
            showCheckBox={userPermission?.archiveAccess}
            onChangeCheckBox={handleOnChangeCheckBox}
            onChangeFilter={(filterValues) => {
              const sortValues = filterValues?.sort;
              let columnUpdate = customerManagementColumn;
              columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
              if (sortValues) {
                columnUpdate = columnUpdate.map((res) => {
                  return {
                    ...res,
                    sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                  };
                });
              }
              setCustomerManagementColumn(columnUpdate);
              if (sortValues) {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, role: filterValues?.filter.selectValue }));
              } else {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, role: filterValues?.filter.selectValue }));
              }
            }}
            sortChange={(sortValues) => {
              const columnUpdate = customerManagementColumn.map((res) => {
                return {
                  ...res,
                  sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                };
              });
              setCustomerManagementColumn([...columnUpdate]);
              setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order }));
            }}
          />
        </Stack>
        {
          <Stack
            sx={{ width: '100%' }}
            className="relative inputFormStyle"
            direction={'row'}
          >
            {userPermission?.archiveAccess && (
              <Button
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    fontSize: '14px',
                    '&:hover': {},
                  },
                ]}
                style={{ width: '230px', height: '48px' }}
                onClick={() => {
                  setOpenArchiveList(true);
                }}
              >
                {t('View archive')}
              </Button>
            )}
            <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
              <TablePagination
                sx={{ borderBottom: 0 }}
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>
          </Stack>
        }
      </Stack>
      <Stack>
        {isDrawerOpen && <UserDetails
          permission={userPermission}
          user={selectedData}
          isDrawerOpen={isDrawerOpen}
          toggleDrawer={() => {
            if (selectedData) {
              handleToggleDrawer();
            }
          }}
          openEditUser={() => {
            setAddEditUserOpen(true);
            setType('edit');
          }}
          init={() => handleGetUser()}
        />}
        
      </Stack>
      {addEditUserOpen && (
        <AddEditUser
          type={type}
          user={selectedData}
          openRolePrivilage={(roleId) => {
            setOpenRolePrivilage(true);
            setRoleId(roleId);
          }}
          modelOpen={addEditUserOpen}
          onModelHandleClose={(event) => {
            if (event) {
              setPayload((prev) => ({ ...prev, page: 1 }));
              handleGetUser();
            }
            setAddEditUserOpen(false);
          }}
        />
      )}
      {openRolePrivilage && (
        <RolePrivilageDialog
          open={openRolePrivilage}
          handleClose={(event) => {
            if (event) {
              //   setPayload((prev) => ({ ...prev, page: 1 }));
              //   getCompanyList();
            }
            setOpenRolePrivilage(false);
          }}
          roleId={roleId}
        />
      )}
      {openArchiveDialog && (
        <ConfirmArchiveDialog
          modelOpen={openArchiveDialog}
          onModelHandleClose={(event) => {
            if (event) {
              setOpenArchiveDialog(false);
              setOpenArchiveList(false);
              setPayload((prev) => ({ ...prev, page: 1 }));
              handleGetUser();
              setSelectedHistory(null)
            }
            setOpenArchiveDialog(false);
          }}
          data={selectedHistory}
          type={'user'}
          status={1}
        />
      )}
      {openArchiveList && (
        <ArchiveUserList
          modelOpen={openArchiveList}
          onModelHandleClose={(event) => {
            setOpenArchiveList(false);
            if(event) {
              setPayload((prev) => ({ ...prev, page: 1 }));
              handleGetUser();
            }
           
          }}
        />
      )}
    </Stack> : <AccessDenied />
  );
}
